import {createContext, Dispatch, PropsWithChildren, SetStateAction, useMemo, useState} from "react";

type NavbarContextValue = {
    navbarOpen: boolean;
    setNavbarOpen: Dispatch<SetStateAction<boolean>>;
};

export const NavbarContext = createContext<NavbarContextValue>({navbarOpen: false, setNavbarOpen: () => {}});

export const NavbarConsumer = ({ children }: PropsWithChildren) => {

    const [navbarOpen, setNavbarOpen] = useState(false);
    const value = useMemo(() => ({navbarOpen, setNavbarOpen}), [navbarOpen]);

    return (
        <NavbarContext.Provider value={value}>
            {children}
        </NavbarContext.Provider>
    );
}
